/* eslint-disable @typescript-eslint/no-explicit-any */

import React from 'react';
import JsonPanel from 'utils/components/JsonPanel/JsonPanel';
import { WidgetPanelGrid } from 'widgets/supportVisualisation/Content/Widgets/WidgetPanelGrid';
import {
    BloombergMessage,
    BloombergStatusMessage,
} from 'app/glue/bloomberg/store/bloombergSlice';

export function SupportVisualisationBloombergMessage(props: {
    message: BloombergMessage | BloombergStatusMessage;
}) {
    const { message } = props;

    if (message.eventType === 'SUBSCRIPTION_DATA') {
        return (
            <SubscriptionData data={(message as BloombergMessage).response} />
        );
    }
    if (message.eventType === 'Response') {
        return <Response message={message} />;
    }
    return (
        <div className="message">
            <JsonPanel data={message} title="Response" />
        </div>
    );
}

function SubscriptionData(props: { data: any }) {
    const eventMessages = props.data.msg.eventMessages;
    if (eventMessages?.length !== undefined) {
        const data = flattenEventMessages(eventMessages);
        return (
            <WidgetPanelGrid
                data={data}
                getRowDataId={(d) => d.id}
                csvFileName={'market-data-messages'}
            />
        );
    }
    return (
        <div className="message">
            <JsonPanel data={props.data} />
        </div>
    );
}

function flattenEventMessages(messages: any[]) {
    return messages.map((m, i) => ({
        id: i.toString(),
        type: m.MarketBarStart
            ? 'MarketBarStart'
            : m.MarketBarUpdate
            ? 'MarketBarUpdate'
            : m.MarketBarIntervalEnd
            ? 'MarketBarIntervalEnd'
            : m.MarketBarEnd
            ? 'MarketBarEnd'
            : 'Unknown',
        ...m.MarketBarStart,
        ...m.MarketBarUpdate,
        ...m.MarketBarIntervalEnd,
        ...m.MarketBarEnd,
    }));
}

function Response(props: { message: any }) {
    const bars = props.message?.response?.data.barTickData;

    if (bars && bars.length > 0) {
        const data = bars.map((b: any, i: number) => ({
            id: i.toString(),
            ...b,
        }));
        return (
            <WidgetPanelGrid
                data={data}
                getRowDataId={(d: any) => d.id}
                csvFileName={'market-data-messages'}
            />
        );
    }
    return (
        <div className="message">
            <JsonPanel data={props.message} />
        </div>
    );
}
